import React from 'react';
import { useTranslation } from 'react-i18next';

export const AdminDashboard = () => {
  const { t } = useTranslation();
  return <div>{t('adminHome')}</div>;
};
